export interface IStudentNameMaskParams {
  schoolId: number;
  coachId?: number;
}

export const getCurrentStudentNameMask = async (
  getStatus: (params: IStudentNameMaskParams) => Promise<any>,
  schoolId: number,
  coachId?: number
): Promise<boolean> => {
  const response = await getStatus(
    coachId === undefined ? { schoolId } : { schoolId, coachId }
  );
  return Boolean(response?.data?.is_mask_student_name);
};



// WEBPACK FOOTER //
// ./src/pages/director/administrators/studentNameMask.ts